import React, { useState, useEffect } from "react";
import Classes from "./styles/style.module.css";
import CustomModal from "../ModalComonent";
import OTPInput from "react-otp-input";
import appApi from "../../utils/AppApi";
import toast from "react-hot-toast";
import { useNavigate, useLocation } from "react-router";
import errorHandler from "../../utils/ErrorHandler";
import { useDispatch, useSelector } from "react-redux";
import {
  setCurrentUser,
  setAuthToken,
  setShowOtp,
} from "../../redux/actions/User";
import Loading from "../../containers/loadingDialog";
import CustomButton from "../CustomButton";
import OtpImage from "../../images/common/otpImage.png";
import UsersRequests from "../../services/user";

const OTP = () => {
  const [otp, setOtp] = React.useState("");
  const [remainingTime, setRemainingTime] = useState(120);
  const [couldSendAgain, setCouldSendAgain] = useState(false);
  const [loading, setloading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { showOtp, checkUserInfo } = useSelector(({ user }) => user);
  let from = location.state?.from?.pathname || "/profile";

  useEffect(() => {
  if ('OTPCredential' in window) {
    navigator.credentials
      .get({
        otp: { transport: ['sms'] },
        signal: new AbortController().signal,
      })
      .then((otpCredential) => {
        if (otpCredential && otpCredential.code) {
          setOtp(otpCredential.code);
        }
      })
      .catch((err) => {
        console.log(err,"error reciving otp");
      });
  }
}, []);

  useEffect(() => {
    if (showOtp === false) {
      return;
    }

    if (remainingTime <= 0) {
      setCouldSendAgain(true);
      return;
    }

    const intervalId = setInterval(() => {
      setRemainingTime((prevTime) => Math.max(prevTime - 1, 0));
    }, 1000);

    return () => clearInterval(intervalId);
  }, [remainingTime, showOtp]);

  const handleChange = (otp) => {
    setOtp(otp);
  };

  const handleSubmitCode = async () => {
    if (otp.length === 5) {
      setloading(true);
      try {
        await appApi
          .post(`/user/loginV2`, {
            nationalCode: checkUserInfo.nationalCode,
            phone: checkUserInfo.phone,
            otp: otp,
          })
          .then((res) => {
            if (res.status === 200) {
              localStorage.setItem("UserToken", res.data.token);
              localStorage.setItem("currentUser", res.data.user.id);
              dispatch(setCurrentUser(res.data.user));
              dispatch(setAuthToken(res.data.token));
              toast.success("باموفقیت به پیشخوان راه بهشت وارد شدید");
              dispatch(setShowOtp(false));
              setOtp("");
              setloading(false);
              navigate(from, { replace: true });
            }
          });
      } catch (error) {
        setOtp("");
        setloading(false);
        errorHandler(error);
      }
    } else {
      toast.error("کد دریافتی را وارد کنید");
    }
  };

  const handleSendOtpAgain = () => {
    setOtp("");
    setRemainingTime(120);
    setCouldSendAgain(false);
    dispatch(UsersRequests.requesteOtp(checkUserInfo, true));
  };

  const handleKeyDown = (event) => {
    if (event.keyCode === 13) {
      handleSubmitCode();
    }
  };

  const OtpContent = (
    <div className={Classes.content}>
      <img src={OtpImage} alt="otp" />
      <h2>{`کد دریافتی به شماره تلفن ${checkUserInfo?.phone} را وارد کنید`}</h2>
      <div className={Classes.OtpContainer} onKeyDown={handleKeyDown}>
        <OTPInput
          inputStyle={Classes.OtpContainerInput}
          value={otp}
          onChange={handleChange}
          numInputs={5}
          renderInput={(props) => <input {...props} />}
          shouldAutoFocus={true}
        />
      </div>
      {couldSendAgain ? null : <div>{`ثانیه باقیمانده ${remainingTime}`}</div>}
      <div className="text-center">
        {loading ? (
          <Loading
            className={"d-flex justify-content-center mt-4 mb-2"}
            size={30}
          />
        ) : couldSendAgain ? (
          <CustomButton
            text={"ارسال دوباره"}
            clickHandler={handleSendOtpAgain}
            color={"primary"}
            shadow
            styles={{ marginTop: "32px" }}
          />
        ) : (
          <CustomButton
            text={"تایید"}
            clickHandler={handleSubmitCode}
            color={"primary"}
            shadow
            styles={{ marginTop: "32px" }}
          />
        )}
      </div>
    </div>
  );

  return (
    <CustomModal
      open={showOtp}
      closeHandler={() => dispatch(setShowOtp(false))}
      dialogContent={OtpContent}
      inputDialog={true}
    />
  );
};

export default OTP;
